import { queryOptions } from '@tanstack/react-query';

import { getWorkspace } from './get-workspace';

export const workspaceQueryKeys = {
  all: ['workspace'] as const,
  details: () => [...workspaceQueryKeys.all, 'detail'] as const,
  detail: (workspaceId: string) =>
    [...workspaceQueryKeys.details(), workspaceId] as const,
};

export function workspaceQueryOptions({
  workspaceId,
}: {
  workspaceId: string;
}) {
  return queryOptions({
    queryKey: workspaceQueryKeys.detail(workspaceId),
    queryFn: () => getWorkspace({ workspace_id: workspaceId }),
  });
}
